// src/pages/admin/CoachList.js
import React, { useEffect, useState } from "react";

const CoachList = () => {
  const [coaches, setCoaches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");

  const sheetCSVUrl =
    "https://docs.google.com/spreadsheets/d/e/2PACX-1vRNmPDTOG-F_ExRksptSy5SiUeqXkDnGTSvKXu5eEX9b3LVb_oQdhR-ihBYG4Fm8yrcFfZ_hUJKWZ0q/pub?output=csv";

  useEffect(() => {
    const fetchCoaches = async () => {
      try {
        setLoading(true);
        setErrorMsg("");

        const res = await fetch(sheetCSVUrl);
        const csvText = await res.text();

        const lines = csvText
          .split("\n")
          .map((l) => l.trim())
          .filter((l) => l.length > 0);

        if (!lines.length) {
          setCoaches([]);
          return;
        }

        const headers = lines[0].split(",").map((h) => h.trim());

        const data = lines.slice(1).map((line) => {
          const values = line.split(",");
          const obj = {};
          headers.forEach((header, index) => {
            obj[header] = values[index]?.trim() || "";
          });
          return obj;
        });

        setCoaches(data);
      } catch (err) {
        console.error("Failed to fetch coaches:", err);
        setErrorMsg("Failed to fetch coach data. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchCoaches();
  }, []);

  return (
    <div className="min-h-screen bg-[#F4F6FB] flex flex-col">
      {/* HEADER */}
      <div className="bg-[#0f2250] text-white sticky top-0 z-20">
        <div className="max-w-6xl  px-4 py-4">
          <h1 className="text-lg font-semibold ms-12 sm:ms-0 mt-1">
            Coach Submissions
          </h1>
        </div>
      </div>

      {/* PAGE CONTENT */}
      <div className="px-4 md:px-6 lg:px-10 py-6 flex-1 overflow-x-hidden overflow-y-auto">
        <div className="max-w-7xl mx-auto w-full">
          {/* Top strip: title + count */}
          <div className="px-2 md:px-0 mb-3 flex items-center justify-between">
            <span className="text-sm font-semibold text-[#0C295F]">
              Coaches List
            </span>
            <span className="text-xs md:text-sm text-gray-500">
              Total: {coaches.length}
            </span>
          </div>

          {/* Card with table */}
          <div className="bg-white rounded-xl p-3 md:p-4 overflow-x-auto shadow-[0_0_6px_rgba(0,0,0,0.2)]">
            {loading && (
              <p className="text-sm text-gray-500">Loading coach data...</p>
            )}

            {errorMsg && (
              <p className="text-sm text-red-500 mb-4">{errorMsg}</p>
            )}

            {!loading && !errorMsg && coaches.length === 0 && (
              <p className="text-sm text-red-500">No coach submissions found.</p>
            )}

            {!loading && !errorMsg && coaches.length > 0 && (
              <table className="min-w-full bg-white text-sm">
                <thead className="bg-[#c4d5f1] text-[#0C295F]">
                  <tr>
                    <th className="px-4 py-3 border-b text-left">#</th>
                    {Object.keys(coaches[0]).map((key) => (
                      <th
                        key={key}
                        className="px-4 py-3 border-b text-left whitespace-nowrap"
                      >
                        {key}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {coaches.map((coach, idx) => (
                    <tr
                      key={idx}
                      className="odd:bg-white even:bg-[#F9FBFF] hover:bg-[#EEF3FF] transition-colors"
                    >
                      <td className="px-4 py-3 border-b align-top">
                        {idx + 1}
                      </td>
                      {Object.values(coach).map((val, i) => (
                        <td
                          key={i}
                          className="px-4 py-3 border-b align-top whitespace-pre-wrap"
                        >
                          {val || "-"}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoachList;
